(function () {
  "use strict";

  var INPUT_ID = "mini-discount-input";
  var APPLY_ID = "mini-discount-apply";
  var WARNING_ID = "mini-discount-warning";

  var sanitize = function (s) { return String(s || "").replace(/[^A-Za-z0-9\-_]/g, "").toUpperCase(); };

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("Cart fetch failed");
      return r.json();
    });
  }

  function setCartCodes(code) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      if (!r.ok) throw new Error("Cart update failed");
      return r.json();
    }).then(function (cart) {
      var codes = cart.discount_codes.filter(function(discount_code) { 
        return discount_code.code === code; 
      });
      
      if (codes.length === 0) {
        showWarning();
        return cart;
      }
      
      var current = codes[0];
      if (current.applicable) {
  hideWarning();

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true,
    detail: { 
      __giftOrchestrator: true,
      ready: true,
      replacementDelay: 0,
      openMiniCart: false,
      reason: 'discount-applied'
    }
  }));

} else {
  showWarning();
}

      return cart;
    });
  }

  function showWarning() {
    var warning = document.getElementById(WARNING_ID);
    var input = document.getElementById(INPUT_ID);
    if (warning) warning.style.display = 'block';
    if (input) input.classList.add('warning');
  }

  function hideWarning() {
    var warning = document.getElementById(WARNING_ID);
    var input = document.getElementById(INPUT_ID);
    if (warning) warning.style.display = 'none';
    if (input) input.classList.remove('warning');
  }

  function addCode(raw) {
    var clean = sanitize(raw);
    if (!clean) return Promise.resolve();
    return setCartCodes(clean).catch(function () {
      showWarning();
    });
  }

  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === APPLY_ID) {
      var input = document.getElementById(INPUT_ID);
      if (!input) return;
      
      hideWarning();
      e.target.disabled = true;
      addCode(input.value).finally(function () {
        input.value = "";
        e.target.disabled = false;
      });
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.target && e.target.id === INPUT_ID && e.key === "Enter") {
      e.preventDefault();
      var applyBtn = document.getElementById(APPLY_ID);
      if (applyBtn) applyBtn.click();
    }
  });
})();